import React, {
  useEffect,
  useRef,
  useState,
  useImperativeHandle,
  forwardRef,
  useCallback
} from 'react';
import gsap from 'gsap';
import './SlotsAnimation.css';

let ICON_MAP = {}
let ICON_KEYS = {}
const SPIN_DIRECTION = {
  UP: 'up',
  DOWN: 'down'
}
let GameImages = (imgs, Dummy_imgs) => {
  ICON_MAP = imgs
  ICON_KEYS = Object.keys(ICON_MAP);
}

ICON_KEYS = Object.keys(ICON_MAP || {});
const ICON_WIDTH = 218;
const ICON_HEIGHT = 218;
const ICON_SPACING_X = 30;
const ICON_SPACING_Y = 30;

// const ICON_WIDTH = 210;
// const ICON_HEIGHT = 210;
// const ICON_SPACING_X = 40;
// const ICON_SPACING_Y = 40;

const VISIBLE_ROWS = 3;
let REELS = 5;
const DUMMY_LENGTH = 50;
const X_OFFSET = 5;

const ICON_CENTER = 10;

const SPIN_SPEED = {
  NORMAL: {
    baseDuration: 2.2,     // base spin time
    reelDelay: 0.25,       // stagger between reels
    ease: 'power2.inOut'
  },
  TURBO: {
    baseDuration: 0.9,     // very fast
    reelDelay: 0.07,
    ease: 'power1.out'
  }
};

const SlotCanvas = forwardRef((props, ref) => {
  REELS = props.Reels
  const spinDirectionRef = useRef(props.SpinDirection);
  const canvasRef = useRef(null);
  const [imagesLoaded, setImagesLoaded] = useState(false);
  const [isSpinning, setIsSpinning] = useState(false);
  const preloadedImages = useRef({});
  const reelData = useRef([]);
  const yOffsetsRef = useRef(new Array(REELS).fill(0));
  const winningIcons = useRef([]);
  const pulseIcons = useRef([])
  const isTurboRef = useRef(false);
  const winLoopInterval = useRef(null);
  const winLineIndex = useRef(0);

  const payoutlist = [
    { linesCount: 1, backGroung_G_clr: ['#cb950d', '#c41d0a'], active: true, payoutLine: [1, 1, 1, 1, 1], clr: "#fa7705" }, // 1
  ]
  useEffect(() => {
    const loadImages = async () => {
      const promises = ICON_KEYS.map(key => {
        return new Promise(resolve => {
          const img = new Image();
          img.src = ICON_MAP[key];
          img.onload = () => {
            preloadedImages.current[key] = img;
            resolve();
          };
        });
      });
      await Promise.all(promises);
      setImagesLoaded(true);

      reelData.current = Array(REELS).fill().map(() =>
        Array(DUMMY_LENGTH + VISIBLE_ROWS).fill().map(() =>
          ICON_KEYS[Math.floor(Math.random() * ICON_KEYS.length)]
        )
      );
      if (canvasRef.current) drawAll();
    };
    loadImages();
  }, []);

  const getWinningLines = () => {
    const w = winningIcons.current;
    if (!w || w.length === 0) return [];
    // if items are objects with positions property
    if (w[0] && w[0].positions) return w;
    // if it's a flat array of pairs, wrap as single line (no lineId)
    if (Array.isArray(w[0]) && typeof w[0][0] === 'number') {
      return [{ lineId: null, positions: w }];
    }
    return [];
  };
  const getWinningPulse = () => {
    const wp = pulseIcons.current;
    if (!wp || wp.length === 0) return [];
    // if items are objects with positions property
    if (wp) return wp;
    // if it's a flat array of pairs, wrap as single line (no lineId)
    if (Array.isArray(wp[0]) && typeof wp[0][0] === 'number') {
      return wp;
    }
    return [];
  };

  const drawAll = useCallback(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    if (!canvas) return;
    if (!ctx) return;
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    for (let r = 0; r < REELS; r++) {
      const yOffset = yOffsetsRef.current[r];
      const reel = reelData.current[r];
      for (let i = 0; i < reel.length; i++) {
        const iconKey = reel[i];
        const img = preloadedImages.current[iconKey];
        const x = r * (ICON_WIDTH + ICON_SPACING_X) + X_OFFSET;
        const y = i * (ICON_HEIGHT + ICON_SPACING_Y) + yOffset;

        const center_iconX = x + ICON_CENTER;
        const center_iconY = y + ICON_CENTER;

        if (y > -ICON_HEIGHT && y < (ICON_HEIGHT + ICON_SPACING_Y) * VISIBLE_ROWS) {
          ctx.save();

          if (props.GameType != "Retro") {
            props.createBGColors({
              ctx: ctx,
              canvas: canvas,
              x: x,
              y: y,
              ICON_WIDTH: ICON_WIDTH,
              ICON_HEIGHT: ICON_HEIGHT
            })
          }

          // ctx.drawImage(img, x, y, ICON_WIDTH, ICON_HEIGHT);
          ctx.drawImage(img, center_iconX, center_iconY, ICON_WIDTH, ICON_HEIGHT);
          ctx.restore();
           if (props.GameType == "GangsterParty") {
            props.createBGColors({
              ctx: ctx,
              canvas: canvas,
              x: x,
              y: y,
              ICON_WIDTH: ICON_WIDTH,
              ICON_HEIGHT: ICON_HEIGHT
            })
          }
        }

      }
    }
    if (props.GameType == "Retro") {
      props.createLineMain({
        ctx: ctx,
        canvas: canvas
      })
    }
    props.CreateWinAnimateLines({
      ctx: ctx,
      canvas: canvas,
      ICON_WIDTH: ICON_WIDTH,
      ICON_HEIGHT: ICON_HEIGHT,
      X_OFFSET: X_OFFSET,
      ICON_SPACING_Y: ICON_SPACING_Y,
      ICON_SPACING_X: ICON_SPACING_X,
      Winning_Lines: getWinningLines(),
      Winning_pulseIcons: getWinningPulse(),
      reelData: reelData,
      DUMMY_LENGTH: DUMMY_LENGTH,
      preloadedImages: preloadedImages,
      ICON_CENTER: ICON_CENTER,
      DirectionSpin: spinDirectionRef.current
    })

    // drawWinningLines(ctx);
    // highlightWinningIcons(ctx);

  }, []);

  useEffect(() => {
    if (!imagesLoaded) return;

    let animationFrameId;

    const animate = () => {
      if (
        isSpinning ||
        (winningIcons.current && winningIcons.current.length > 0)
      ) {
        drawAll();
      }
      animationFrameId = requestAnimationFrame(animate);
    };

    animate();
    return () => cancelAnimationFrame(animationFrameId);
  }, [drawAll, imagesLoaded, isSpinning]);


  const stopWinLineLoop = () => {
    clearInterval(winLoopInterval.current);
    winLoopInterval.current = null;
    winLineIndex.current = 0;
  };
  const startWinLineLoop = (winPositions, pulsePositions, winAmount) => {
    clearInterval(winLoopInterval.current);

    if (!winPositions.length) return;

    winLineIndex.current = 0;
    // Show win amount once
    // props.setWinsAndAmount(winAmount);

    winLoopInterval.current = setInterval(() => {
      const index = winLineIndex.current;

      winningIcons.current = winPositions[index].positions;
      pulseIcons.current = pulsePositions[index];

      drawAll();

      winLineIndex.current = (winLineIndex.current + 1) % winPositions.length;

    }, 2500); // 👈 control speed here
  };

  const BetspinReels = (FinalReels, WinningReels, winAmount, pulseIndexs) => {
    console.log(FinalReels)
    console.log(WinningReels)
    console.log(winAmount)
    if (isSpinning || !imagesLoaded) return;
    
    stopWinLineLoop();
    const normalizedWinningReels =
      Array.isArray(WinningReels[0]) || WinningReels.length === 0
        ? WinningReels // multiple lines or empty
        : [WinningReels]; // single line (wrap it)

    const windata = {
      result: FinalReels,
      winningPositions: normalizedWinningReels.map((line, lineIndex) => ({
        lineId: lineIndex,
        positions: line.map((rowIndex, reelIndex) => [reelIndex, rowIndex])
      }))

    }
    const result = windata.result.map(
      col => col.map(idx => ICON_KEYS[idx])
    );

    // const newReels = [];
    // for (let i = 0; i < REELS; i++) {
    //   const dummy = Array(DUMMY_LENGTH).fill().map(() => ICON_KEYS[Math.floor(Math.random() * ICON_KEYS.length)]);
    //   newReels[i] = [...dummy, ...result[i]];
    // }
    const newReels = [];
    for (let i = 0; i < REELS; i++) {
      const dummy = Array(DUMMY_LENGTH)
        .fill()
        .map(() => ICON_KEYS[Math.floor(Math.random() * ICON_KEYS.length)]);

      if (spinDirectionRef.current === SPIN_DIRECTION.UP) {
        newReels[i] = [...dummy, ...result[i]];
      } else {
        // DOWN (default)
        newReels[i] = [...result[i], ...dummy];
      }
    }
    reelData.current = newReels;
    yOffsetsRef.current = new Array(REELS).fill(0);
    winningIcons.current = [];

    setIsSpinning(true);
    props.SetSpinDisable(true)

    for (let i = 0; i < REELS; i++) {
      const distance = DUMMY_LENGTH * (ICON_HEIGHT + ICON_SPACING_Y);

      const offsetObj = {
        value: spinDirectionRef.current === SPIN_DIRECTION.UP
          ? 0
          : -distance // 👈 VERY IMPORTANT for DOWN
      };
      const speedProfile = isTurboRef.current ? SPIN_SPEED.TURBO : SPIN_SPEED.NORMAL;

      const spinDuration = speedProfile.baseDuration + i * speedProfile.reelDelay;

      gsap.to(offsetObj, {
        value: spinDirectionRef.current === SPIN_DIRECTION.UP
          ? -distance
          : 0,
        // duration: 2.2 + i * 0.25,
        // ease: 'power2.inOut',
        duration: spinDuration,
        ease: speedProfile.ease,
        onUpdate: () => {
          yOffsetsRef.current[i] = offsetObj.value;
          drawAll();
        },
        onComplete: () => {
          if (i === REELS - 1) {
            // winningIcons.current = windata.winningPositions
            if (windata.winningPositions && windata.winningPositions.length > 0 && winAmount) {
              setIsSpinning(false);
              const totalLines = windata.winningPositions.length;
              const DelayIndex = 2000
              windata.winningPositions.forEach((w, index) => {
                setTimeout(() => {
                  console.log("Animating line:", w.positions);
                  console.log("pulse animation:", pulseIndexs[index]);
                  winningIcons.current = w.positions;
                  pulseIcons.current = pulseIndexs[index]
                  drawAll();
                  // If this is the last line, then stop spinning and enable buttons
                  if (index === totalLines - 1) {
                    setTimeout(() => {
                      setIsSpinning(false);
                      // props.SetSpinDisable(false);
                    }, DelayIndex); // same delay as one animation
                    props.setWinsAndAmount(winAmount) // Animation start
                    startWinLineLoop(windata.winningPositions, pulseIndexs, winAmount);
                  }
                }, index * DelayIndex);
              });
            } else {
              // No winning lines — stop immediately
              setIsSpinning(false);
              props.AfterSpinHit()
              props.setAutoPlayCount()
              props.getGameState()
            }

            // drawAll(); // draw again with glow          
          }
        }
      });
    }
  };

  useImperativeHandle(ref, () => ({
    spinofcheck(reels, WinningReels, amount, pulseIndexs) {
      BetspinReels(reels, WinningReels, amount, pulseIndexs);
    },
    GameImgs(imgs, Dummy_imgs) {
      GameImages(imgs, Dummy_imgs)
    },
    setTurboMode(value) {
      isTurboRef.current = value;
    }
  }));



  return (
    <div className="MainDivSlot">
      <div className="slot-wrapper">
        <canvas
          ref={canvasRef}
          width={REELS * (ICON_WIDTH + ICON_SPACING_X)}
          height={VISIBLE_ROWS * (ICON_HEIGHT + ICON_SPACING_Y)}
          className="slot-canvas"
        />
      </div>
    </div>
  );
});

export default SlotCanvas;
